class LocaleService {
    public getLocale() {
        return "en-GB";
    }
}

export default new LocaleService();
